import useRevealOnScroll from '../Home/hooks/useRevealOnScroll'
import './leadershipNew.scss'
import CanSeeItSection from './sections/CanSeeItSection/CanSeeItSection'
import FinalCTASection from './sections/FinalCTASection/FinalCTASection'
import GapSection from './sections/GapSection/GapSection'
import HardToSeeSection from './sections/HardToSeeSection/HardToSeeSection'
import HeroSection from './sections/HeroSection/HeroSection'
import StructuralRealitySection from './sections/StructuralRealitySection/StructuralRealitySection'
import StructureToApplicationSection from './sections/StructureToApplicationSection/StructureToApplicationSection'
import UnderlyingStructureSection from './sections/UnderlyingStructureSection/UnderlyingStructureSection'
import WhatLeadershipNetIsSection from './sections/WhatLeadershipNetIsSection/WhatLeadershipNetIsSection'
import WhatThisLooksLikeSection from './sections/WhatThisLooksLikeSection/WhatThisLooksLikeSection'

const LeadershipNewPage = () => {
  useRevealOnScroll()

  return (
    <main className="lnn-page">
      <HeroSection />
      <WhatLeadershipNetIsSection />
      <StructuralRealitySection />
      <WhatThisLooksLikeSection />
      <HardToSeeSection />
      <CanSeeItSection />
      <UnderlyingStructureSection />
      <GapSection />
      <StructureToApplicationSection />
      <FinalCTASection />
    </main>
  )
}

export default LeadershipNewPage
